import { InlineAlert } from '@rbilabs/universal-components';

import { Box } from 'components/ui';

export const IncentiveEvaluationMessagesContainer = Box;

export const SingleMessage = InlineAlert.withConfig({
  marginBottom: '$2',
  focusable: true,
});
